export default "__VITE_ASSET__Bl2ewYNY__"